import "@/App.css";
import { ReactLenis } from "lenis/react";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import ProductMediaCenter from "@/pages/ProductMediaCenter";
import CorporatePage from "@/pages/CorporatePage";
import BrandsPage from "@/pages/BrandsPage";
import DealershipPage from "@/pages/DealershipPage";
import DealerNetworkPage from "@/pages/DealerNetworkPage";
import FaqPage from "@/pages/FaqPage";
import ContactPage from "@/pages/ContactPage";
import DocumentLibraryPage from "@/pages/DocumentLibraryPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { ScrollProgress } from "@/components/site/ScrollProgress";
import i18n from "@/i18n";
import { applyDocumentLanguage, SUPPORTED_LOCALES } from "@/lib/locale";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function LocalizedPage({ children }) {
  const { locale } = useParams();

  useEffect(() => {
    const language = SUPPORTED_LOCALES.includes(locale) ? locale : "tr";
    localStorage.setItem("nolena-language", language);
    i18n.changeLanguage(language);
    applyDocumentLanguage(language);
  }, [locale]);

  return children;
}

function LegacyResourceCenterRedirect() {
  const { locale } = useParams();

  if (locale) return <Navigate to={`/${locale}/urun-kaynak-merkezi`} replace />;
  return <Navigate to="/urun-kaynak-merkezi" replace />;
}

function LegacyProductsRedirect() {
  const { locale } = useParams();

  if (locale) return <Navigate to={`/${locale}/markalar#kategoriler`} replace />;
  return <Navigate to="/markalar#kategoriler" replace />;
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
          <div className="App">
            <BrowserRouter>
              <ScrollToTop />
              <Routes>
                <Route path="/" element={<Home />} />
            <Route path="/hakkimizda" element={<CorporatePage />} />
            <Route path="/markalar" element={<BrandsPage />} />
            <Route path="/urunler" element={<LegacyProductsRedirect />} />
            <Route path="/bayilik" element={<DealershipPage />} />
            <Route path="/bayiler" element={<DealerNetworkPage />} />
            <Route path="/sss" element={<FaqPage />} />
            <Route path="/iletisim" element={<ContactPage />} />
            <Route path="/urun-medya-merkezi" element={<LegacyResourceCenterRedirect />} />
            <Route path="/urun-kaynak-merkezi" element={<ProductMediaCenter />} />
            <Route path="/sertifikalar" element={<DocumentLibraryPage type="certificate" />} />
            <Route path="/kataloglar" element={<DocumentLibraryPage type="catalog" />} />
            <Route path="/belgeler" element={<DocumentLibraryPage />} />
            <Route path="/:locale" element={<LocalizedPage><Home /></LocalizedPage>} />
            <Route path="/:locale/hakkimizda" element={<LocalizedPage><CorporatePage /></LocalizedPage>} />
            <Route path="/:locale/markalar" element={<LocalizedPage><BrandsPage /></LocalizedPage>} />
            <Route path="/:locale/urunler" element={<LocalizedPage><LegacyProductsRedirect /></LocalizedPage>} />
            <Route path="/:locale/bayilik" element={<LocalizedPage><DealershipPage /></LocalizedPage>} />
            <Route path="/:locale/bayiler" element={<LocalizedPage><DealerNetworkPage /></LocalizedPage>} />
            <Route path="/:locale/sss" element={<LocalizedPage><FaqPage /></LocalizedPage>} />
            <Route path="/:locale/iletisim" element={<LocalizedPage><ContactPage /></LocalizedPage>} />
            <Route path="/:locale/urun-medya-merkezi" element={<LocalizedPage><LegacyResourceCenterRedirect /></LocalizedPage>} />
            <Route path="/:locale/urun-kaynak-merkezi" element={<LocalizedPage><ProductMediaCenter /></LocalizedPage>} />
            <Route path="/:locale/sertifikalar" element={<LocalizedPage><DocumentLibraryPage type="certificate" /></LocalizedPage>} />
            <Route path="/:locale/kataloglar" element={<LocalizedPage><DocumentLibraryPage type="catalog" /></LocalizedPage>} />
            <Route path="/:locale/belgeler" element={<LocalizedPage><DocumentLibraryPage /></LocalizedPage>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <ScrollProgress />
        <Toaster position="top-center" richColors />
      </div>
    </ReactLenis>
  );
}

export default App;
